import { SortDirection } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, SortConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SORT: DeepPartial<SortConfig> = {
  sorts: [
    {
      title: 'RELEVANCE',
      value: ''
    },
    {
      title: 'SCORE',
      value: 'externalScore desc',
      direction: SortDirection.DESC
    },
    {
      title: 'PRICE_ASC',
      value: 'price asc',
      direction: SortDirection.ASC
    },
    {
      title: 'PRICE_DESC',
      value: 'price desc',
      direction: SortDirection.DESC
    },
    {
      title: 'NAME_ASC',
      value: 'nameSort asc',
      direction: SortDirection.ASC
    },
    {
      title: 'NAME_DESC',
      value: 'nameSort desc',
      direction: SortDirection.DESC
    },
    {
      title: 'YEAR_DESC',
      value: 'dateRelease desc',
      direction: SortDirection.DESC
    }
  ],
  components: {
    sortIcon: 'EbxChevronRightIcon', sort: 'EbxSortDropdown',
    dropdown: {
      beforeItems: 'CdlCloseSortDropdown'
    },
  },
  iconSlot: 'dropdown-icon'
};

export const DESKTOP_SORT: DeepPartial<SortConfig> = {
  components: {
    sortIcon: COMPONENTS.PURE.ChevronUpIcon,
    dropdown: { beforeItems: null }
  }
};
